import { render, staticRenderFns } from "./app.vue?vue&type=template&id=3ca4f6f0&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"
import style0 from "./app.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/apps/bowling/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ca4f6f0')) {
      api.createRecord('3ca4f6f0', component.options)
    } else {
      api.reload('3ca4f6f0', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=3ca4f6f0&", function () {
      api.rerender('3ca4f6f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/pages/app.vue"
export default component.exports